import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const VOUCHER_STATUSES = {
  ACTIVE: 'ACTIVE',
  SCHEDULED: 'SCHEDULED',
  EXPIRED: 'EXPIRED',
  INACTIVE: 'INACTIVE',
};

export const getVoucherStatus = (voucher, referenceDate) => {
  if (!voucher?.active) return VOUCHER_STATUSES.INACTIVE;

  const now = referenceDate ? dayjs(referenceDate) : dayjs();
  if (voucher.valid_from && dayjs(voucher.valid_from).isAfter(now)) return VOUCHER_STATUSES.SCHEDULED;
  if (voucher.valid_until && dayjs(voucher.valid_until).isBefore(now)) return VOUCHER_STATUSES.EXPIRED;

  return VOUCHER_STATUSES.ACTIVE;
};

export const getVoucherStatusColor = (status) => {
  if (status === VOUCHER_STATUSES.ACTIVE) return 'success';
  if (status === VOUCHER_STATUSES.SCHEDULED) return 'warning';
  if (status === VOUCHER_STATUSES.EXPIRED) return 'error';
  return 'default';
};

export const formatVoucherDiscount = (voucher, translate = (value) => value) => {
  const value = Number(voucher?.discount_value);
  if (!Number.isFinite(value)) return '-';

  if (voucher.discount_type === 'PERCENT') return `${value}%`;
  if (voucher.discount_type === 'FIXED') return `${value.toFixed(2)} ${translate('Lei')}`;

  return '-';
};

export const formatVoucherDate = (value) => (value ? dayjs(value).format('DD MMM YYYY, HH:mm') : null);

export const toNullableNumber = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  return Number(value);
};

export const toApiDate = (value) => (value ? value.toISOString() : null);
